import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BaseFiniteScrollCarousel } from "@faire/retailer-visitor-shared/components/Carousel/FiniteScrollCarousel/BaseFiniteScrollCarousel";
import { Pill } from "@faire/retailer-visitor-shared/components/LoggedOutPills/Pill";
import { Column, HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import chunk from "lodash/chunk";
import React from "react";
import styled from "styled-components";
export var StackedPillsWithTitle = function(param) {
    var pills = param.pills, title = param.title, pillsCta = param.pillsCta, isLoading = param.isLoading, className = param.className, useCarouselOnMobile = param.useCarouselOnMobile, leftAlign = param.leftAlign, includeHairline = param.includeHairline, mobileItemsPerSlide = param.mobileItemsPerSlide, onView = param.onView;
    var isMobile = useViewport().isMobile;
    var viewRef = useDoActionWhenVisible(onView);
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        ref: onView ? viewRef : undefined,
        children: [
            title ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    includeHairline ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(HorizontalLine, {}),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "5x"
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx(Header, {
                        align: leftAlign || isMobile ? "left" : "center",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "2x",
                            tabletAndAbove: "3x"
                        }
                    })
                ]
            }) : null,
            isLoading ? /*#__PURE__*/ _jsx(LoadingSpinner, {
                size: "medium"
            }) : null,
            isMobile && useCarouselOnMobile ? /*#__PURE__*/ _jsx(StyledPillsMwebCarousel, {
                pills: pills,
                mobileItemsPerSlide: mobileItemsPerSlide
            }) : /*#__PURE__*/ _jsxs(PillsContainer, {
                $leftAlign: leftAlign,
                children: [
                    pills.map(function(pill) {
                        return /*#__PURE__*/ _jsx(Pill, {
                            pill: pill
                        }, pill.pillContent);
                    }),
                    pillsCta ? /*#__PURE__*/ _jsxs(CtaWrapper, {
                        children: [
                            " ",
                            pillsCta,
                            " "
                        ]
                    }) : null
                ]
            })
        ]
    });
};
var PillsMwebCarousel = function(param) {
    var pills = param.pills, className = param.className, mobileItemsPerSlide = param.mobileItemsPerSlide;
    var elementRef = React.useRef(null);
    return /*#__PURE__*/ _jsx(BaseFiniteScrollCarousel.BaseFiniteScrollCarousel, {
        forwardRef: elementRef,
        name: "search-products-related-search-list-carousel",
        shouldHideRightButton: true,
        shouldHideLeftButton: true,
        className: className,
        children: mobileItemsPerSlide ? /*#__PURE__*/ _jsx(StyledColumn, {
            children: chunk(pills, mobileItemsPerSlide).map(function(pillsChunk, chunkIndex) {
                return /*#__PURE__*/ _jsx(PillCarouselRow, {
                    children: pillsChunk.map(function(pill, pillIndex) {
                        var totalIndex = chunkIndex * mobileItemsPerSlide + pillIndex;
                        return /*#__PURE__*/ _jsx(Pill, {
                            pill: pill
                        }, totalIndex);
                    })
                }, chunkIndex);
            })
        }) : /*#__PURE__*/ _jsx(StyledRow, {
            children: pills.map(function(pill, pillIndex) {
                return /*#__PURE__*/ _jsx(Pill, {
                    pill: pill
                }, pillIndex);
            })
        })
    });
};
var StyledRow = styled(Row).attrs({
    gap: "1x"
}).withConfig({
    componentId: "sc-a24886a2-0"
})([
    "padding:",
    ";flex-wrap:wrap;min-width:200vw;"
], getSpacing(0, "2x"));
var StyledPillsMwebCarousel = styled(PillsMwebCarousel).withConfig({
    componentId: "sc-a24886a2-1"
})([
    "margin:",
    ";width:unset;"
], getSpacing(0, "-2x"));
var StyledColumn = styled(Column).withConfig({
    componentId: "sc-a24886a2-2"
})([
    "padding:",
    ";"
], getSpacing(0, "2x"));
var PillCarouselRow = styled(Row).attrs({
    align: "flex-start",
    gap: "1x"
}).withConfig({
    componentId: "sc-a24886a2-3"
})([
    "&:not(:first-child){margin-top:",
    ";}"
], getSpacing("1x"));
var CtaWrapper = styled.div.withConfig({
    componentId: "sc-a24886a2-4"
})([
    "padding-left:4px;align-self:center;"
]);
// eslint-disable-next-line @faire/prefer-slate-attrs -- move justify to a responsive prop
var PillsContainer = styled(Row).attrs({
    gap: "1x"
}).withConfig({
    componentId: "sc-a24886a2-5"
})([
    "width:100%;flex-wrap:wrap;justify-content:",
    ";",
    "{justify-content:left;}"
], function(param) {
    var leftAlign = param.$leftAlign;
    return leftAlign ? "left" : "center";
}, responsiveMediaQueries.mobile);
var Header = styled(Typography).attrs({
    variant: "pageHeaderSerifRegular",
    truncate: true,
    forwardedAs: "h4"
}).withConfig({
    componentId: "sc-a24886a2-6"
})([
    "&&&{padding-left:4px;word-break:break-word;white-space:normal;",
    "{padding-left:0;}}"
], responsiveMediaQueries.tabletAndAbove);
var Wrapper = styled.div.withConfig({
    componentId: "sc-a24886a2-7"
})([
    "padding-top:0;width:100%;"
]);
